import { Provider } from '@angular/core';
import { PortfolioRepositoryPort } from '../domain/repositories/portfolio.repository.port';
import { PortfolioRepository } from './repositories/portfolio.repository';

export const PORTFOLIO_PROVIDERS: Provider[] = [
  {
    provide: PortfolioRepositoryPort,
    useClass: PortfolioRepository,
  },
];
